import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAdmin = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="M12 1c1.596 0 2.964.943 3.606 2.296a3.99 3.99 0 0 1 4.173.926 3.99 3.99 0 0 1 .926 4.173A3.99 3.99 0 0 1 23 12a3.99 3.99 0 0 1-2.295 3.606 3.99 3.99 0 0 1-.926 4.172 3.99 3.99 0 0 1-4.173.927A3.99 3.99 0 0 1 12.001 23a3.99 3.99 0 0 1-3.606-2.295 3.99 3.99 0 0 1-4.173-.927 3.99 3.99 0 0 1-.926-4.172A3.99 3.99 0 0 1 1 12a3.99 3.99 0 0 1 2.296-3.605 3.99 3.99 0 0 1 .926-4.173 3.99 3.99 0 0 1 4.173-.926A3.99 3.99 0 0 1 12 1m6 15.263H6v2h12zM18 6l-3.333 3.421L12 6 9.333 9.421 6 6v8.895h12z"
        />
    </svg>
);
export default SvgAdmin;
